import * as constants from './constants'
import type { Plugin } from './plugin'

/**
 * Selectors for joint-use state and the target-scoped edited organization.
 */
export class Selectors {
  /** Selector indicating if the data is being loaded from the backend */
  // NOTE: Intentionally not typed here so that type can be inferred
  public readonly isLoading

  /** Loaded joint-use functionalizations */
  // NOTE: Intentionally not typed here so that type can be inferred
  public readonly functionalizations

  /** Selector indicating if there was an error while fetching */
  // NOTE: Intentionally not typed here so that type can be inferred
  public readonly error

  /** Current edited organization's joint-use calculation mode */
  // NOTE: Intentionally not typed here so that type can be inferred
  public readonly calculationMode

  constructor(plugin: Plugin) {
    this.isLoading = plugin.feature.state.project(state => state.isLoading)
    this.functionalizations = plugin.feature.state.project(
      state => state.functionalizations,
    )
    this.error = plugin.feature.state.project(state => state.error)
    this.calculationMode =
      plugin.collection.plugins.currentEntityPlugin.feature.selectors
        .getEditedEntity({ target: constants.CURRENT_ENTITY_TARGET })
        .project(organization => organization?.jointUseInfo?.calculationMode)
  }
}
